import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class ResgateConsultaService {

  @Output() consultaAtualizando = new EventEmitter<boolean>();
  @Output() atualizarStatusRecarregar = new EventEmitter<boolean>();

  constructor(private httpClient: HttpClient) { }
  
  carregarConsultaDecisaoCerta(token, ignore = []) {
  
    return this.httpClient.get(environment.wsUrl + 'decisaoCerta/carregarConsulta/' + token, {
      params: { ignore: ignore },
    }).toPromise();
  }
  
  carregarConsulta(id, ignore = []) {
    return this.httpClient.get(environment.wsUrl + 'consultaVeiculo/carregarConsulta/' + id, {
      params: { ignore: ignore },
    }).toPromise();
  }

  carregarConsultaCliente(id, ignore = []) {
    return this.httpClient.get(environment.wsUrl + 'consultaVeiculo/carregarConsultaCliente/' + id, {
      params: { ignore: ignore },
    }).toPromise();
  }

  resgatarConsulta(data, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'consultaVeiculo/resgatarConsulta', data, {
      params: { ignore: ignore },
    }).toPromise();
  }

  refazerConsulta(nomeConsulta, idConsulta, ignore = ['loading']) {
    
    return this.httpClient.get(environment.wsUrl + 'consultaVeiculo/refazerConsulta/'+nomeConsulta+'/'+idConsulta, {
      params: { ignore: ignore },
    }).toPromise();
  }


  downloadPdfConsulta(data, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'relatorio/relatorioConsultaPdf' , data, {
      params: { ignore: ignore }, responseType: 'blob' 
    }).toPromise();
  }

  salvarFotosConsulta(token, observacoes, fotos, ignore = []) {
    let data = {token: token, observacoes: observacoes, fotos:fotos}
    return this.httpClient.post(environment.wsUrl + 'consultaVeiculo/salvarImagensConsulta', data, {params: {ignore: ignore}}).toPromise();
  }

  atualizarStatus(e: boolean) {
    this.consultaAtualizando.emit(e);
  }

  atualizarStatusGlobal(e: boolean) {
    this.atualizarStatusRecarregar.emit(e);
  }

}
